<template>

  <modalo
    :creating="creating"
    :title="!creating ? `Evento - ${$d(new Date(event.start_at), 'long')}` : null"
    type="mini"
    @hideModal="hideModal()">

      <div v-if="!creating">
        <div class="row mb-2">
          <label class="col-sm-3"><strong>{{ $t('Candidates') }}</strong></label>
          <div class="col-sm-9">
            <div
              v-for="(item, index) in event.events"
              :key="index">
              <router-link :to="toRouteCandidate(item.candidate._id, event.job_id._id)">{{ item.candidate.name }}</router-link>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <label class="col-sm-3"><strong>{{ $t('Job') }}</strong></label>
          <div class="col-sm-9">
            <router-link :to="{path: '/job/' + event.job_id._id }">{{ event.job_id.title }}</router-link>
          </div>
        </div>
        <div class="row mb-2">
          <label class="col-sm-3"><strong>{{ $t('Start date') }}</strong></label>
          <div class="col-sm-9">
            {{ $d(new Date(event.start_at), 'long') }}
          </div>
        </div>
        <div class="row mb-2">
          <label class="col-sm-3"><strong>{{ $t('Duration') }}</strong></label>
          <div class="col-sm-9">
            {{ event.duration }} minutos
          </div>
        </div>
        <div class="row mb-2">
          <label class="col-sm-3"><strong>{{ $t('Type') }}</strong></label>
          <div class="col-sm-9">
            {{ event.type }}
          </div>
        </div>
        <div
          v-if="event.meet_link"
          class="row mb-2">
          <label class="col-sm-3"><strong>URL Vídeo</strong></label>
          <div class="col-sm-9">
            <a :href="event.meet_link" target="_blank">{{ event.meet_link }}</a>
          </div>
        </div>
        <div
          v-if="event.assigned_users && event.assigned_users.length >= 1"
          class="row">
          <label class="col-sm-3"><strong>{{ $t('Participants') }}</strong></label>
          <div class="col-sm-9">
            <span
              v-for="(item, index) in event.assigned_users"
              :key="index">
              {{ item.name }}<span v-if="index < (event.assigned_users.length - 1)">, </span>
              </span>
          </div>
        </div>
        <div
          v-if="event.participants && event.participants.length >= 1"
          class="row">
          <label class="col-sm-3"><strong>{{ $t('Guests') }}</strong></label>
          <div class="col-sm-9">
            <span
              v-for="(item, index) in event.participants"
              :key="index"
              :title="item.email">
              {{ item.name || item.email }}<span v-if="index < (event.participants.length - 1)">, </span>
              </span>
          </div>
        </div>
        <div class="row mb-2" v-if="event.location">
          <label class="col-sm-3"><strong>{{ $t('Location') }}</strong></label>
          <div class="col-sm-9">
            {{ event.location }}
          </div>
        </div>
        <div v-if="event.note">
          <hr>
          <div class="row">
            <label class="col-sm-3"><strong>{{ $t('Note') }}</strong></label>
            <div class="col-sm-9">
              <div style="white-space: pre-wrap;">{{ event.note }}</div>
            </div>
          </div>
        </div>
      </div>

  </modalo>

</template>

<script>
export default {
  name: 'CalendarEvent',
  components: {
  },
  props: [
    'eventId'
  ],
  data () {
    return {
      creating: true,
      loading: true
    }
  },
  computed: {
    event () {
      return this.$store.getters.getCalendarEvent
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      this.$store
      .dispatch('selectCalendarEvent', this.eventId)
      .then((result) => {
        this.loading = this.creating = false
      })
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    toRouteCandidate
    */
    toRouteCandidate (candidateId, jobId) {
      return {
        query: {
          ...this.$clone(this.$route.query),
          candidate_id: candidateId,
          candidate_job_id: jobId
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Calendar/CalendarEvent.vue